/* SALT Ñ SOUL — Mobiles Menü */
(function () {
  'use strict';
  var menu = document.querySelector('[data-mobile-menu]');
  if (!menu) return;
  var openers = document.querySelectorAll('[data-menu-open]');
  var lastFocus = null;

  function open() {
    lastFocus = document.activeElement;
    menu.setAttribute('aria-hidden', 'false');
    document.body.classList.add('menu-open');
    openers.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var first = menu.querySelector('.mobile-menu__close');
    if (first) first.focus();
  }
  function close() {
    menu.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('menu-open');
    openers.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (lastFocus) lastFocus.focus();
  }

  openers.forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); open(); }); });
  menu.querySelectorAll('[data-menu-close]').forEach(function (b) { b.addEventListener('click', close); });
  menu.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && menu.getAttribute('aria-hidden') === 'false') close(); });
  window.matchMedia('(min-width: 1024px)').addEventListener('change', function (e) { if (e.matches) close(); });
})();

/* SALT Ñ SOUL — Vorbestellung: Texte, die theme.js beim Variantenwechsel setzt, umschreiben */
(function () {
  'use strict';
  var map = {
    'In den Warenkorb': 'Jetzt vorbestellen',
    '+ In den Warenkorb': '+ Jetzt vorbestellen',
    'Auf Lager': 'Vorbestellung – Versand ab 2. November'
  };
  function fix(el) {
    var t = (el.textContent || '').trim();
    if (map[t] && el.textContent !== map[t]) el.textContent = map[t];
  }
  function scan() {
    document.querySelectorAll('[data-add-label], [data-variant-status], .product-card__quick button').forEach(fix);
  }
  document.addEventListener('DOMContentLoaded', scan);
  scan();
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
})();
